import React, { Component } from 'react';

import CommonService from '../../services/commonService';
import PropTypes from 'prop-types';

export default class KuposButton extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
  };

  render() {
    const operator = CommonService.getLocal('op') || this.props.operator;
    return (
      <button
        style={
          operator && operator.operator_name && operator.color_codes
            ? {
                background:
                  operator.operator_name === 'serenamar'
                    ? !this.props.disabled
                      ? operator.color_codes.footer_color
                      : ''
                    : !this.props.disabled
                    ? operator.color_codes.button_color
                    : '',
                color:
                  operator.operator_name === 'combarbala'
                    ? '#000'
                    : operator.operator_name === 'busnorte'
                    ? operator.color_codes.header_color
                    : '',
                ...this.props.style,
              }
            : {}
        }
        className={'kupos-button ' + this.props.className}
        disabled={this.props.disabled}
        onClick={this.props.onClick}
      >
        <span>{this.props.children}</span>{' '}
      </button>
    );
  }
}


// WEBPACK FOOTER //
// ./src/features/common/KuposButton.js